<template>
    <div class="flex items-center gap-2">
        <p v-if="values.length > 0" class="px-3 py-2 rounded-full text-14px transition-colors"
            :class="getTagStyle()">
            {{ values[0] }}
        </p>
        <p v-if="values.length > 2" class="px-3 py-2 rounded-full text-14px transition-colors"
            :class="getTagStyle()">
            {{ values[1] }}
        </p>
        <p v-if="values.length === 2" class="px-3 py-2 rounded-full text-14px transition-colors"
            :class="getTagStyle()">
            {{ values[1] }}
        </p>
        <p v-if="values.length > 2" class="px-3 py-2 rounded-full text-14px transition-colors"
            :class="getTagStyle()">
            +{{ values.length - 2 }}
        </p>
    </div>
</template>

<script>
export default {
    name: "Capsule",
    props: {
        values: {
            type: Array,
            default: () => []
        },
        color: {
            type: String,
            default: 'blue'
        }
    },
    methods: {
        getTagStyle() {
            const colorMap = {
                'blue': 'bg-blue-100 text-blue-800',
                'green': 'bg-green-100 text-green-800',
                'red': 'bg-red-100 text-red-800',
                'gray': 'bg-gray-100 text-gray-800',
                'yellow': 'bg-yellow-100 text-yellow-800'
            }
            const colorScheme = colorMap[this.color];
            return colorScheme;
        }
    }
}
</script>

<style scoped>
.text-14px {
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 140%;
}
</style>
